import { configureStore } from "@reduxjs/toolkit";
import accountReducer from "./slices/account";
import authReducer from "./slices/auth";
import { clientInquiryApi } from "./slices/client-inquiries";
import { volunteerInquiryApi } from "./slices/volunteer-inquiries";

// prototype
import opsReducer from "./slices/prototype/ops";
import passRequestReducer from "./slices/prototype/passRequest";
import residentsReducer from "./slices/prototype/residents";
import incidentReportsReducer from "./slices/prototype/incidentReports";
import uaFormReducer from "./slices/prototype/uaForm";
import usersReducer from "./slices/users";
import walkInServicesReducer from "./slices/prototype/walkInServices";
import dailyDutiesReducer from "./slices/prototype/dailyDuties";
import friendlyRemindersReducer from "./slices/prototype/friendlyReminders";
import kitchenPrototypeReducer from "./slices/prototype/kitchen";
import houseDisplayReducer from "./slices/prototype/houseDisplay";

import { kennyismsApi, menuItemsApi, mealsApi } from "./slices/kitchen";

export const store = configureStore({
  reducer: {
    account: accountReducer,
    auth: authReducer,
    [clientInquiryApi.reducerPath]: clientInquiryApi.reducer,
    [volunteerInquiryApi.reducerPath]: volunteerInquiryApi.reducer,

    // prototype
    ops: opsReducer,
    passRequest: passRequestReducer,
    residents: residentsReducer,
    incidentReports: incidentReportsReducer,
    uaForm: uaFormReducer,
    users: usersReducer,
    walkInServices: walkInServicesReducer,
    dailyDuties: dailyDutiesReducer,
    friendlyReminders: friendlyRemindersReducer,
    kitchen: kitchenPrototypeReducer,
    houseDisplay: houseDisplayReducer,
    [kennyismsApi.reducerPath]: kennyismsApi.reducer,
    [menuItemsApi.reducerPath]: menuItemsApi.reducer,
    [mealsApi.reducerPath]: mealsApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      clientInquiryApi.middleware,
      volunteerInquiryApi.middleware,

      // prototype
      kennyismsApi.middleware,
      menuItemsApi.middleware,
      mealsApi.middleware,
    ),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
